const TOKEN_KEY = 'access_token'
const USER_INSTANCE = 'user_instance'
const REFRESHER_TOKEN_KEY = 'refresh_token'
const ADMIN_PROFILE = 'admin_profile'
const EXPIRED_TOKEN_TIME = 'expired_token_time'

/**
 * Manage the how Access Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instace.
 **/

const TokenService = {
  removeExpiredTokenTime() {
    localStorage.removeItem(EXPIRED_TOKEN_TIME)
  },
  getExpiredTokenTime() {
    return localStorage.getItem(EXPIRED_TOKEN_TIME)
  },
  saveExpiredTokenTime(time) {
    localStorage.setItem(EXPIRED_TOKEN_TIME, time)
  },
  getToken() {
    return localStorage.getItem(TOKEN_KEY)
  },
  saveToken(accessToken) {
    localStorage.setItem(TOKEN_KEY, accessToken)
  },
  removeToken() {
    localStorage.removeItem(TOKEN_KEY)
  },

  getUser() {
    return localStorage.getItem(USER_INSTANCE) || null
  },
  saveUser(userInstance) {
    localStorage.setItem(USER_INSTANCE, userInstance)
  },
  removeUser() {
    localStorage.removeItem(USER_INSTANCE)
  },

  getRefreshToken() {
    return localStorage.getItem(REFRESHER_TOKEN_KEY)
  },
  saveRefreshToken(refresh_token) {
    localStorage.setItem(REFRESHER_TOKEN_KEY, refresh_token)
  },
  removeRefreshToken() {
    localStorage.removeItem(REFRESHER_TOKEN_KEY)
  },

  // getBusinessProfile() {
  //   return localStorage.getItem(BUSINESS_PROFILE);
  // },
  // saveBusinessProfile(business_profile) {
  //   localStorage.setItem(BUSINESS_PROFILE, business_profile);
  // },

  getAdminProfile() {
    return localStorage.getItem(ADMIN_PROFILE)
  },
  saveAdminProfile(admin_profile) {
    localStorage.setItem(ADMIN_PROFILE, admin_profile)
  },
  removeAdminProfile() {
    localStorage.removeItem(ADMIN_PROFILE)
  },
}
export { TokenService }
